// File: src/pages/auth/ForgotPasswordPage.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authApi } from "@/lib/axios";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", msg: "" });

    const cid = Number(String(companyId || "").trim());
    if (!Number.isInteger(cid) || cid <= 0) {
      setStatus({ type: "error", msg: "Please enter a valid Company ID." });
      return;
    }
    if (!email.trim()) {
      setStatus({ type: "error", msg: "Please enter your email." });
      return;
    }

    setLoading(true);
    try {
      await authApi.post("/forgot-password", {
        company_id: cid,
        email: email.trim(),
      });

      // Always generic success to avoid email enumeration
      setStatus({
        type: "ok",
        msg: "If that account exists, a reset link has been sent to the email.",
      });
    } catch (_err) {
      // Even on error, keep it generic (prevents info leakage + keeps UX consistent)
      setStatus({
        type: "ok",
        msg: "If that account exists, a reset link has been sent to the email.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#05060f] text-white grid place-items-center p-6">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white/5 p-6 shadow-2xl backdrop-blur-xl">
        <h1 className="text-xl font-bold">Forgot password</h1>
        <p className="mt-1 text-sm text-white/60">
          Enter your Company ID and email. We’ll send a reset link if the account exists.
        </p>

        <form onSubmit={submit} className="mt-5 space-y-3">
          <label className="block text-sm">
            <span className="text-white/80">Company ID</span>
            <input
              value={companyId}
              onChange={(e) => setCompanyId(e.target.value.replace(/\D/g, ""))}
              className="mt-1 w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 outline-none focus:border-indigo-400"
              placeholder="e.g. 13"
              inputMode="numeric"
              required
            />
          </label>

          <label className="block text-sm">
            <span className="text-white/80">Email</span>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 outline-none focus:border-indigo-400"
              placeholder="you@company.com"
              type="email"
              required
            />
          </label>

          {status.msg && (
            <div
              className={`rounded-lg border px-3 py-2 text-sm ${
                status.type === "ok"
                  ? "border-emerald-500/30 bg-emerald-500/10 text-emerald-200"
                  : "border-red-500/30 bg-red-500/10 text-red-200"
              }`}
            >
              {status.msg}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className={`w-full rounded-xl py-2 font-medium transition ${
              loading
                ? "cursor-not-allowed bg-indigo-900/40"
                : "bg-gradient-to-r from-indigo-600 via-purple-600 to-emerald-600"
            }`}
          >
            {loading ? "Sending…" : "Send reset link"}
          </button>
        </form>

        <p className="mt-4 text-sm text-white/60">
          Back to{" "}
          <Link className="text-indigo-300 underline underline-offset-2" to="/login">
            sign in
          </Link>
        </p>
      </div>
    </div>
  );
}